import { render, staticRenderFns } from "./ProductModificators.vue?vue&type=template&id=ae2bae72&scoped=true&"
import script from "./ProductModificators.vue?vue&type=script&lang=js&"
export * from "./ProductModificators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2bae72",
  null
  
)

export default component.exports